const DIRECTIVE_NAME = 'ktFlightSearchDepartDateValidator';

export default function FlightSearchDepartDateValidator(
    userService,
    timeService,
) {
    'ngInject';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, elem, $attrs, ngModelCtrl) {
            function validate() {
                const selectedDateAttr = $attrs[`${DIRECTIVE_NAME}SelectedDate`];
                const workingHoursRestrictionsAttr = $attrs[`${DIRECTIVE_NAME}WorkingHoursRestrictions`];
                if (!selectedDateAttr || !workingHoursRestrictionsAttr) {
                    return true;
                }

                const date = moment($scope.$eval(selectedDateAttr), userService.getRegionalSettings().dateFormat);
                const workingHoursRestrictions = $scope.$eval(workingHoursRestrictionsAttr);

                return workingHoursRestrictions || !timeService.isToday(date);
            }

            ngModelCtrl.$validators[DIRECTIVE_NAME] = validate;
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/kt-flight-search-depart-date-validator.js